import { render, staticRenderFns } from "./SSelectPlagueCultive.vue?vue&type=template&id=25052743"
import script from "./SSelectPlagueCultive.vue?vue&type=script&lang=js"
export * from "./SSelectPlagueCultive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports